import { faCheckCircle, faUserCheck, faUserGraduate, faUserTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import DonutChart, { ChartDataItem } from '../../component/Charts/DonutChart'
import CetLoader from '../../component/Loader/CetLoader'
import { useTheme } from '../../theme/useTheme'

interface IReverificationsOverview {
    data: any
    chartData: any
    loading: boolean
}

export default function ReverificationOverview({ data, chartData, loading }: IReverificationsOverview) {
    const { colors } = useTheme()

    const verified = data?.uniqueVerifications || 0
    const total = data?.assignedStudents || 0
    const absent = total - verified
    const pct = total > 0 ? ((verified / total) * 100).toFixed(1) : '0.0'

    const statCards = [
        {
            label: 'Total Assigned',
            value: total.toLocaleString(),
            icon: faUserGraduate,
            accent: colors.primary.main,
            bg: `rgba(72,107,173,0.08)`,
        },
        {
            label: 'Verified',
            value: verified.toLocaleString(),
            icon: faCheckCircle,
            accent: '#10b981',
            bg: 'rgba(16,185,129,0.08)',
        },
        {
            label: 'Absent',
            value: absent.toLocaleString(),
            icon: faUserTimes,
            accent: '#f59e0b',
            bg: 'rgba(245,158,11,0.08)',
        },
        {
            label: 'Attendance',
            value: `${pct}%`,
            icon: faUserCheck,
            accent: colors.primary.light,
            bg: `rgba(91,143,199,0.08)`,
        },
    ]

    if (loading) {
        return (
            <div style={cardStyle}>
                <CetLoader />
            </div>
        )
    }

    return (
        <div style={cardStyle}>
            <div style={{ marginBottom: 20 }}>
                <p style={{ margin: 0, fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', color: colors.text.secondary, textTransform: 'uppercase' }}>Overview</p>
                <h5 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: colors.text.primary }}>Reverification Summary</h5>
            </div>

            <Row className="g-3 mb-3">
                {statCards.map((s) => (
                    <Col xs={6} key={s.label}>
                        <div style={{
                            background: s.bg,
                            borderRadius: 12,
                            padding: '14px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            border: `1px solid ${s.accent}22`,
                        }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: 10,
                                background: `${s.accent}18`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                            }}>
                                <FontAwesomeIcon icon={s.icon} style={{ color: s.accent, fontSize: 18 }} />
                            </div>
                            <div>
                                <div style={{ fontSize: 20, fontWeight: 700, color: colors.text.primary, lineHeight: 1.1 }}>{s.value}</div>
                                <div style={{ fontSize: 11, color: colors.text.secondary, marginTop: 2 }}>{s.label}</div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

            {chartData.length > 0 && data ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <DonutChart
                        data={chartData}
                        height={220}
                        width={220}
                        showTooltip={true}
                        showLegend={true}
                        showCalloutLabels={false}
                    />
                </div>
            ) : (
                <EmptyState message="No data yet." />
            )}
        </div>
    )
}

const cardStyle: React.CSSProperties = {
    background: '#fff',
    borderRadius: 16,
    border: '1px solid #e5e7eb',
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
    padding: 24,
    marginTop: 24,
    height: '100%',
}

const EmptyState = ({ message }: { message: string }) => (
    <div style={{ textAlign: 'center', padding: '32px 0', color: '#9ca3af', fontSize: 14 }}>{message}</div>
)
